var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{attrs:{"id":"employer-resources"}},[_c('view-subnav-section',{attrs:{"title":"Employer Resources","routed":"","links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }